// Update image paths to match actual files in /public/img/
export const FACILITIES = [
  {
    id: "outdoor-stadium",
    nameHi: "आउटडोर स्टेडियम",
    nameEn: "Outdoor Stadium",
    type: "outdoor",
    location: "कंकड़बाग, पटना",
    pricePerSlot: 100,
    capacity: 22,
    rating: 5,
    reviewCount: 1200,
    ratingScore: 9.5,
    images: [
      "/img/outdoor-stadium-1.jpg",
      "/img/outdoor-stadium-2.jpg",
      "/img/outdoor-stadium-3.jpg",
    ],
    listingImage: "/img/outdoor-stadium-1.jpg",
    description:
      "पटना में स्थित पाटलिपुत्र स्पोर्ट्स कॉम्प्लेक्स (जो बिहार की राजधानी के कंकड़बाग क्षेत्र में स्थित है) एक प्रमुख बहु-खेल स्थल है, जो एथलेटिक्स, प्रतिस्पर्धी आयोजनों और सामुदायिक खेल गतिविधियों का केंद्र है। इसका निर्माण वर्ष 2012 में हुआ था और इसका संचालन बिहार राज्य खेल प्राधिकरण द्वारा किया जाता है।\n\nलगभग 16 एकड़ क्षेत्र में फैला यह परिसर आउटडोर और इनडोर दोनों प्रकार की खेल सुविधाओं से युक्त है। आउटडोर स्टेडियम में लगभग 20,000 दर्शकों के बैठने की क्षमता है, जबकि इनडोर एरिना में लगभग 3,500 लोगों के बैठने की व्यवस्था है।",
  },
  {
    id: "indoor-stadium",
    nameHi: "इनडोर स्टेडियम",
    nameEn: "Indoor Stadium",
    type: "indoor",
    location: "कंकड़बाग, पटना",
    pricePerSlot: 100,
    capacity: 22,
    rating: 5,
    reviewCount: 1200,
    ratingScore: 9.5,
    images: [
      "/img/indoor-stadium-1.jpg",
      "/img/indoor-stadium-2.jpg",
      "/img/indoor-stadium-3.jpg",
    ],
    listingImage: "/img/indoor-stadium-1.jpg",
    description:
      "पाटलिपुत्र स्पोर्ट्स कॉम्प्लेक्स का इनडोर स्टेडियम विश्व स्तरीय सुविधाओं से युक्त है। यहाँ बास्केटबॉल, वॉलीबॉल, बैडमिंटन, जिम्नेजियम, कबड्डी, कुश्ती, बॉक्सिंग, जूडो, टेबल टेनिस और स्विमिंग पूल जैसी इनडोर खेल सुविधाएँ उपलब्ध हैं। इसकी क्षमता लगभग 3,500 दर्शकों की है और यह पूर्णतः वातानुकूलित है।",
  },
];

export const TIME_SLOTS = [
  { id: "slot-1", label: "6 AM - 8 AM",   startTime: "06:00 AM", endTime: "08:00 AM", durationHours: 2 },
  { id: "slot-2", label: "8 AM - 10 AM",  startTime: "08:00 AM", endTime: "10:00 AM", durationHours: 2 },
  { id: "slot-3", label: "10 AM - 12 PM", startTime: "10:00 AM", endTime: "12:00 PM", durationHours: 2 },
  { id: "slot-4", label: "12 PM - 2 PM",  startTime: "12:00 PM", endTime: "02:00 PM", durationHours: 2 },
  { id: "slot-5", label: "2 PM - 4 PM",   startTime: "02:00 PM", endTime: "04:00 PM", durationHours: 2 },
  { id: "slot-6", label: "4 PM - 6 PM",   startTime: "04:00 PM", endTime: "06:00 PM", durationHours: 2 },
  { id: "slot-7", label: "6 PM - 8 PM",   startTime: "06:00 PM", endTime: "08:00 PM", durationHours: 2 },
];

export const HERO_IMAGES = [
  "/img/booking-hero-1.jpg",
  "/img/booking-hero-2.jpg",
  "/img/booking-hero-3.jpg",
];

export function getFacilityById(id) {
  return FACILITIES.find((f) => f.id === id);
}

export const BOOKING_API =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5002"
    : "https://api.biharsports.org";
